import React from 'react';
import { Slider, Typography } from '@mui/material';
import { TextElement } from '../types/TextElement';
import type { Slot } from '../types/Slot';
import type { ShapeElement } from '@/types/ShapeElement';

interface OpacityControlProps {
    selectedElement: { type: 'text' | 'slot' | 'shape'; id: string } | null;
    texts: TextElement[];
    slots: Slot[];
    shapes: ShapeElement[];
    onChangeOpacity: (element: { type: 'text' | 'slot' | 'shape'; id: string; opacity: number }) => void;
    disabled?: boolean;
}

const OpacityControl: React.FC<OpacityControlProps> = ({
    selectedElement,
    texts,
    slots,
    shapes,
    onChangeOpacity,
    disabled,
}) => {

    const getSelectedOpacity = () => {
        if (!selectedElement) return 1;

        if (selectedElement.type === 'text') {
            const text = texts.find(t => t.id === selectedElement.id);
            return text?.opacity ?? 1;
        } else if (selectedElement.type === 'slot') {
            const slot = slots.find(slot => slot.id === selectedElement.id);
            return slot?.opacity ?? 1;
        } else if (selectedElement.type === 'shape') {
            const shape = shapes.find(s => s.id === selectedElement.id);
            return shape?.opacity ?? 1;
        }

        return 1;
    };

    const handleOpacityChange = (event: Event | React.ChangeEvent<HTMLInputElement>, value: number | number[]) => {
        if (!selectedElement) return;
        const opacityValue = typeof value === 'number' ? value : value[0];
        // Convert from 0-100 to 0-1
        onChangeOpacity({ ...selectedElement, opacity: opacityValue / 100 });
    };

    return (
        <div>
            <div className="effects-control-wrapper" >
            <Typography gutterBottom>Opacity</Typography>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Slider
                    value={getSelectedOpacity() * 100} // scale to 0-100
                    onChange={handleOpacityChange}
                    min={0}
                    max={100}
                    step={1}
                    disabled={disabled}                    
                    sx={{
                        height: 6,
                        width: '100%',
                        '& .MuiSlider-thumb': { width: 16, height: 16, backgroundColor: "#fff", border: 1},
                        '& .MuiSlider-rail': { height: 4, color: "#59b3d8"},
                        '& .MuiSlider-track': { height: 4, color: "#59b3d8" },
                    }}
                />
                <input
                    type="number"
                    min={0}
                    max={100}
                    step={1}
                    value={Math.round(getSelectedOpacity() * 100)}
                    onChange={(e) => handleOpacityChange(e as any, parseFloat(e.target.value))}
                    style={{
                        width: 35,
                        textAlign: 'right',
                        fontSize: 14,
                        border: '1px solid #ccc',
                        outline: 'none',
                        MozAppearance: 'textfield', // removes arrows in Firefox
                        WebkitAppearance: 'none',   // removes arrows in Chrome/Safari
                        marginLeft: 4,
                    }}
                />
            </div>
            </div>
        </div>
    );
};

export default OpacityControl;
